import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '@shared/ui/fx-sidebar/sidebar.component';
import { LoadingService } from '@core/services/loading.service';
import { PalantirProgressComponent } from '@flux/design-system';
@Component({
  selector: 'main-layout',
  templateUrl: './main.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterOutlet, SidebarComponent, PalantirProgressComponent],
})
export class MainLayoutComponent {
  constructor(public loadingService: LoadingService) {}
}
